import CustomFilterSelect from '../../shared/customFilterSelect';
import BreadCrumb from '../../components/breadCrumb';
import './style.scss';
import { useEffect, useState } from 'react';
import { getAllBeneficiaries, getList } from '../../API/apiService';
import BeneficiaryItem from '../../components/characterizationAdmin/beneficiaryItem';
import DownloadBeneficiaries from '../../components/downloadBeneficiaries';
import { useLoader } from '../../contexts/loader/loader';

function CharacterizationAdmin() {
  const { show } = useLoader();

  const [beneficiaries, setBeneficiaries] = useState([]);
  const [genders, setGenders] = useState([]);
  const itemsDescription = [
    {
      name: 'Nombre',
      code: 'CDE',
      value: 1
    },
    {
      name: 'Documento',
      code: 'TDE',
      value: 2
    },
    {
      name: 'Código de escuela',
      code: 'GRP',
      value: 0
    },
    {
      name: 'Grupo',
      code: 'DMZ',
      value: 3
    },
    {
      name: 'Año',
      code: 'CO',
      value: 4
    },
    {
      name: 'Comuna',
      code: 'BAR',
      value: 5
    },
    {
      name: 'Estado',
      code: 'TDR',
      value: 6
    },
    {
      name: 'Acción',
      code: 'OM',
      value: 7
    }
  ];

  const schoolCode = [
    {
      name: 'E1C1',
      code: 'CDE',
      value: 1
    },
    {
      name: 'E2C2',
      code: 'TDE',
      value: 2
    },
    {
      name: 'E1C3',
      code: 'DMZ',
      value: 3
    },
    {
      name: 'E2C1',
      code: 'CO',
      value: 4
    },
    {
      name: 'E2C2',
      code: 'BAR',
      value: 5
    },
    {
      name: 'E2C3',
      code: 'TDR',
      value: 6
    },
    {
      name: 'E3C1',
      code: 'OM',
      value: 7
    },
    {
      name: 'E3C2',
      code: 'AÑ',
      value: 8
    },
    {
      name: '',
      code: 'V',
      value: 9
    }
  ];

  const groups = [
    {
      name: 'grupo 1',
      id: 1
    },
    {
      name: 'grupo 2',
      id: 2
    },
    {
      name: 'grupo 3',
      id: 3
    },

    {
      name: 'grupo 4',
      id: 4
    },
    {
      name: 'grupo 5',
      id: 5
    }
  ];
  const comuna = [
    {
      name: 'Comuna 1',
      code: 'C1',
      value: 1
    },
    {
      name: 'Comuna 2',
      code: 'C2',
      value: 1
    },
    {
      name: 'Comuna 3',
      code: 'C3',
      value: 1
    },
    {
      name: 'Comuna 4',
      code: 'C4',
      value: 1
    },
    {
      name: 'Comuna 5',
      code: 'C5',
      value: 1
    },
    {
      name: 'Comuna 6',
      code: 'C6',
      value: 1
    }
  ];
  const barrios = [
    {
      name: 'Castilla',
      code: 'CA',
      value: 1
    },
    {
      name: 'Aranjuez',
      code: 'AR',
      value: 1
    },
    {
      name: 'Campo valdez',
      code: 'CV',
      value: 1
    },
    {
      name: 'Manrique',
      code: 'MA',
      value: 1
    },
    {
      name: 'Zamora',
      code: 'ZA',
      value: 1
    }
  ];

  const year = [
    {
      name: '2015',
      code: '2015',
      value: 1
    },
    {
      name: '2016',
      code: '2016',
      value: 1
    },
    {
      name: '2017',
      code: '2017',
      value: 1
    },
    {
      name: '2018',
      code: '2018',
      value: 1
    },
    {
      name: '2019',
      code: '2019',
      value: 1
    }
  ];

  async function loadBeneficiaries() {
    await show(true);
    const b = await getAllBeneficiaries();
    await show(false);
    if (b) {
      setBeneficiaries(b);
    }
  }

  async function loadGenders() {
    const b = await getList('gender');
    if (b) {
      setGenders(b);
    }
  }

  useEffect(() => {
    loadBeneficiaries();
    loadGenders();
  }, []);
  return (
    <>
      <section className='characterizationAdmin-main-container'>
        <BreadCrumb />
        <div className='filters-container'>
          <DownloadBeneficiaries
            beneficiaries={beneficiaries}
            genders={genders}
          />
          <div className='filters-top'>
            <p className='title'>FILTROS DE BÚSQUEDA DE BENEFICIARIOS</p>
          </div>
          <div className='filters-content'>
            <label className='label name' htmlFor=''>
              <input
                placeholder='Nombre completo'
                type='text'
                className='input-form'
              />
            </label>
            <label className='label id' htmlFor=''>
              <input
                placeholder='Documento de identidad'
                type='number'
                className='input-form'
              />
            </label>
            <CustomFilterSelect
              optionsList={schoolCode}
              placeholder={'Código de escuela'}
            />

            <CustomFilterSelect optionsList={groups} placeholder={'Grupo'} />
            <CustomFilterSelect optionsList={year} placeholder={'Año'} />

            <CustomFilterSelect optionsList={comuna} placeholder={'Comuna'} />
            <CustomFilterSelect optionsList={barrios} placeholder={'Barrio'} />
          </div>
        </div>
        <div className='beneficiaries-main-container'>
          <div className='beneficiaries-top'>
            <p className='title'>BENEFICIARIOS</p>
            <p className='paginator-text'>
              | Mostrando <span>16</span> resultados |
            </p>
          </div>
          <div className='info-beneficiaries-content'>
            <BeneficiaryItem
              itemsDescription={itemsDescription}
              beneficiaries={beneficiaries}
            />
          </div>
        </div>
      </section>
    </>
  );
}

export default CharacterizationAdmin;
